import styles from "./SocialShare.module.css";
import Instagram from "../Social/Instagram/Instagram";
import Facebook from "../Social/Facebook/Facebook";
import Pinterest from "../Social/Pinterest/Pinterest";

const SocialShare = () => {
  return (
    <div className={styles.socialShare}>
      <div className={styles.socials}>
        <Instagram />
        <Facebook />
        <Pinterest />
      </div>
    </div>
  );
};

export default SocialShare;
